import styled from "styled-components";

export const Container = styled.div<{ $hasImage: boolean }>`
  display: grid;
  grid-template-columns: ${(props) =>
    props.$hasImage ? "auto minmax(0, 1fr)" : "minmax(0, 920px)"};
  align-items: center;
  gap: clamp(2rem, 6vw, 5rem);

  @media (max-width: 640px) {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }
`;

export const Image = styled.img`
  display: block;
  width: clamp(140px, 20vw, 220px);
  aspect-ratio: 1;
  object-fit: cover;
  border-radius: 50%;
  border: 5px solid rgba(32, 33, 36, 0.15);

  @media (max-width: 640px) {
    width: 140px;
  }
`;

export const Copy = styled.div`
  max-width: 780px;
`;

export const Title = styled.h2`
  margin: 0 0 1rem;
  color: ${(props) => props.theme.color.darkBg};
  font-size: clamp(2rem, 4vw, 3rem);
  line-height: 1.15;
`;

export const Text = styled.p`
  margin: 0;
  color: ${(props) => props.theme.color.darkBg};
  font-size: clamp(1.05rem, 1.6vw, 1.25rem);
  line-height: 1.75;
`;
